import {useQuery} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'
import type {AgentQuotaSnapshot} from '../types/agent-quota-snapshot'

type AgentQuotaSnapshotResponse = {
  agentQuotaSnapshot?: AgentQuotaSnapshot
}

export function useAgentQuotaSnapshot({enabled = true}: {enabled?: boolean} = {}) {
  // eslint-disable-next-line @github-ui/github-monorepo/require-query-persister -- Quota state is user/session-scoped and time-sensitive; persisting stale quota can block/enable assignment incorrectly.
  return useQuery<AgentQuotaSnapshot | undefined>({
    queryKey: ['copilot-assignment', 'agent-quota-snapshot'],
    queryFn: async () => {
      try {
        const response = await reactFetch('/copilot/agent-sessions/quota-snapshot', {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })

        if (!response.ok) {
          return undefined
        }

        const data = (await response.json()) as AgentQuotaSnapshotResponse
        return data.agentQuotaSnapshot
      } catch {
        return undefined
      }
    },
    enabled,
  })
}
